import React from 'react';
import EstimationBlock from '../templates/common/estimationBlock';
import SliderControllerBlock from '../templates/common/sliderControllerBlock';
import formatCurrencyToLocal from '../../../helpers/utils/formatCurrencyToLocal';
import { plural } from 'utils/plural';

export default function template(context) {
    const calc = context.calc,
      model = calc.state.model;

  const estimationData = [
    {
      label: calc.l10n('CALCULATOR_NEW_BUSINESS_DEPOSITS_ESTIMATION_PERCENT_RATE'),
      value: `${model.getRealRate()}${calc.l10n('PERCENT')}`,
    },
    {
      label: calc.l10n('CALCULATOR_NEW_BUSINESS_DEPOSITS_ESTIMATION_INCOME'),
      value: `${formatCurrencyToLocal(model.getIncome())} ${calc.l10n('UAH_ICON')}`,
    }
  ];
  
  return (
    <>
      <div className="calculator-new__top top-calculator-new">
        <div className="top-calculator-new__body">
          <h2 className="top-calculator-new__title">{calc.l10n('CALCULATOR_NEW_BUSINESS_DEPOSITS_TITLE')}</h2>
        </div>
      </div>
      <div className="calculator-new__bottom">
        <SliderControllerBlock
          title={calc.l10n('CALCULATOR_NEW_BUSINESS_DEPOSITS_CONTROLLER_SUM_TITLE')}
          titleNote={`${calc.l10n('CALCULATOR_NEW_BUSINESS_DEPOSITS_CONTROLLER_SUM_TITLE_NOTE_01')} ${model.getMinSumEdge().toLocaleString('uk-UA')} ${calc.l10n('CALCULATOR_NEW_BUSINESS_DEPOSITS_CONTROLLER_SUM_TITLE_NOTE_02')}`}
          inputName="creditSum"
          value={model.getCreditSum()}
          currency={calc.l10n('UAH_ICON')}
          min={model.getMinSumEdge()}
          max={model.getMaxSumEdge()}
          step={model.getSumStep()}
          currencyOffset={calc.state.valueWith}
          hiddenValueRef={calc.hiddenValue}
          onInputChange={calc.handleChangeInput}
          onInputBlur={calc.blurChangeInput}
          onRangeChange={calc.handleChange}
          showError={calc.state.error}
          errorText={`${calc.l10n("CALCULATOR_CREDIT_ERROR_TEXT")} ${model.getMinSumEdge().toLocaleString('uk-UA')} ${calc.l10n('UAH_ICON')}`}
        />
        <EstimationBlock
          title={calc.l10n('CALCULATOR_NEW_ESTIMATION_TITLE')}
          items={estimationData}
        />
        <div className='calculator-new__hint-info'>{calc.l10n("CALCULATOR_NEW_BUSINESS_DEPOSITS_HINT_INFO")}</div>
        <button 
          className="calculator-new__order-btn" 
          onClick={calc.props.toggleModal} 
          id={`${calc.props.page ? calc.props.page : ''} calculator-new-button`}
        >
          {calc.l10n('CALCULATOR_NEW_BUSINESS_DEPOSITS_BTN')}
        </button>
      </div>
    </>
  );
}
